module.exports = __webpack_public_path__ + "img/flag_bg.61736812.svg";